import React, { useState, useEffect } from "react";
import { Modal } from "react-responsive-modal";
import { ReactComponent as ShareIcon } from "assets/img/icons/share-list.svg";
import { useSelector } from "react-redux";
import Scrollbar from "react-scrollbars-custom";
import Button from "components/CustomButton";
import { useToasts } from "react-toast-notifications";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import Loader from "components/Loader";
import TeamService from "services/TeamService";
import { CSSTransition } from "react-transition-group";

var styles = {
  headingDailog: {
    fontWeight: "600",
  },
  listIteamHeading: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px",
    gap: "15px",
    borderBottom: "1px solid #ccc",
  },
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    borderBottom: "1px solid #ccc",
    cursor: "pointer",
  },
  teamDetail: {
    display: "flex",
    gap: "10px",
    fontWeight: "400",
    alignItems: "center",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
  },
  dialogContent: {
    height: "450px",
    maxHeight: "450px",
    overflow: "auto",
    flex: "1 1 auto",
    padding: "8px 24px",
  },
  avatar: {
    minHeight: "30px",
    height: "30px",
    minWidth: "30px",
    width: "30px",
    borderRadius: "50%",
  },
  teamNameAll: {
    fontWeight: "bolder",
  },
  uncheckbox: {
    width: "20px",
    height: "20px",
  },
  checkbox: {
    width: "23px",
    height: "23px",
  },
  rightButton: {
    position: "absolute",
    top: "0",
    right: "0",
  },
  noTeams: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  shareButton: {
    cursor: "pointer",
  },
  loaderClass: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  dialogTitle: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "0 0 auto",
    margin: 0,
    padding: "12px 0px 12px",
  },
  doneButton: {
    width: "100px",
    background: "none",
    height: "unset",
    color: "#ffa100",
    boxShadow: "unset",
  },
};

export default ({ todoList, myteam_id }) => {
  const classes = styles;
  const [dialogState, setDialogState] = useState(false);
  const { addToast } = useToasts();
  const [allTeams, setAllTeams] = useState();
  const [shareteams, setSharedTeams] = useState([]);
  const [loading, setLoading] = useState(false);
  const { teams } = useSelector((state) => state.teamsReducer);
  const [displayComment, setComment] = useState(null);

  useEffect(() => {
    if (teams === undefined) {
      return;
    }

    setAllTeams(
      teams.filter((all_teams) => {
        return all_teams?.id !== myteam_id;
      })
    );
  }, [teams, myteam_id]);

  const ShareList = async (expressionInclude) => {
    setLoading(true);
    await TeamService.shareTodoList(myteam_id, todoList.id, {
      team_id: shareteams,
      include_expressions: expressionInclude,
    });
    setSharedTeams([]);
    setLoading(false);
    setDialogState(false);
    addToast("Your list is shared. ", { appearance: "success" });
  };

  const handleChange = (id) => {
    if (displayComment) {
      setComment(null);
      setSharedTeams(null);
      return;
    }
    setSharedTeams(id);
    setComment(id);
  };

  const checkSrc = (e) => {
    e.target.src = DefaultTeamAvatar;
  };

  return (
    <>
      <span className="icon-edit me-2" onClick={() => setDialogState(true)}>
        <ShareIcon style={{ fill: "#a1a2a9" }} className="mw-20" />
      </span>
      <Modal
        open={dialogState}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        center={true}
        onClose={() => setDialogState(false)}
        showCloseIcon={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "shareModalPadding",
        }}
      >
        <div className="modal fade popup-modal">
          <div className="modal-content">
            <div className="modal-body">
              <div style={classes.dialogTitle}>
                <h5 style={classes.headingDailog}>Select Teams</h5>
                {/* {!!allTeams && allTeams?.length > 0 && (
                  <div style={classes.rightButton}>
                    <Button
                      buttonStyle={classes.doneButton}
                      onClick={ShareList}
                      type="button"
                      name={
                        !loading ? "Done" : <Loader width={20} height={20} />
                      }
                      disabled={(shareteams.length === 0 || loading) && true}
                    />
                  </div>
                )} */}
              </div>
              <div style={classes.dialogContent}>
                <Scrollbar style={{ paddingRight: "10px" }}>
                  <div style={classes.listContainer}>
                    {!allTeams && (
                      <div style={classes.loaderClass}>
                        <Loader />
                      </div>
                    )}
                    {allTeams?.length > 0 && (
                      <div style={classes.listIteamHeading}>
                        <div style={classes.teamDetail}>
                          <span style={classes.teamNameAll}></span>
                        </div>
                      </div>
                    )}
                    {allTeams?.map((allteam) => (
                      <div>
                        <div
                          onClick={() => handleChange(allteam?.id)}
                          style={classes.listItem}
                          key={allteam.id}
                        >
                          <div style={classes.teamDetail}>
                            <img
                              onError={checkSrc}
                              alt={`${allteam.avatar}`}
                              style={classes.avatar}
                              src={allteam.avatar ?? DefaultTeamAvatar}
                            />
                            <span
                              className="postShareTeam"
                              style={classes.teamName}
                            >
                              {allteam.name}
                            </span>
                          </div>
                        </div>
                        <CSSTransition
                          in={displayComment === allteam?.id ? true : false}
                          timeout={300}
                          unmountOnExit
                          classNames="dropdown-element"
                        >
                          <div className="todoCommentMessage">
                            <span>
                              Do you also want to share task engagements?
                            </span>
                            <span className="actionButtons">
                              <span onClick={() => ShareList(true)}>Yes</span>
                              <span onClick={() => ShareList(false)}>No</span>
                            </span>
                          </div>
                        </CSSTransition>
                      </div>
                    ))}
                    {allTeams?.length === 0 && (
                      <div style={classes.noTeams}>
                        <p>You don't have any teams.</p>
                      </div>
                    )}
                  </div>
                </Scrollbar>
              </div>
              <div>
                <Button
                  type="button"
                  disabled={loading && true}
                  buttonClass="small-btn me-2"
                  name="Cancel"
                  onClick={() => setDialogState(false)}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
